import { useEffect, useState, useCallback } from 'react'
import { Switch } from '@headlessui/react'
import moment from 'moment'
import { Menu } from '@headlessui/react'
import CreateCategoryModal from './createCategoryModal'
import category from '../../services/category'



const Category = () => {
    let [showCreateModal, setShowCreateModal] = useState(false)
    const [categories, setCategories] = useState([]);
    const [editItem, setEditItem] = useState();
    const [isEdit, setIsEdit] = useState(false);
    const [name, setName] = useState('');

    const getAll = async () => {
        const res = await category.getAll();
        if (res.data.status === 200) {
            setCategories(res.data.data);
        }
    }

    useEffect(() => {
        getAll();
    }, []);

    const closeModal = () => {
        setIsEdit(false);
        setEditItem();
        setShowCreateModal(false);
        setName();
    }

    const handleCategoryChanges = useCallback((e) => {
        setName(e.target.value);
    }, []);

    const handleEdit = (item) => {
        setShowCreateModal(true);
        setIsEdit(true);
        setEditItem(item);
        console.log({ item })
        setName(item.name);
    }

    const updateCategory = useCallback(async () => {
        const res = await category.update(editItem.uuid, { name });
        if (res.data.status === 200) {
            getAll();
            closeModal()
        }
    }, [name, editItem]);

    const handleSubmit = useCallback(async () => {
        const res = await category.create({ name })
        if (res.data.status === 200) {
            console.log({ res }, 'submit');
            getAll();
            closeModal();
        }
    }, [name]);

    const handleMarkActiveDeActive = async (uuid, value) => {
        const payload = {
            is_active: value
        }
        const res = await category.updateStatus(uuid, payload);
        if (res.data.status === 200) {
            getAll();
        }

    }

    return (
        <>
            <div className="users w-100 h-full flex flex-col">
                <div className="settings-title">
                    <div className="row d-flex d-flex flex-md-fill flex-wrap">
                        <div className="col-md-7 col-6 d-flex flex-md-fill flex-column">
                            <h1 className='text-2xl text-black font-medium mb-0'>All Categories</h1>
                        </div>
                        <div className="col-md-5 col-6 d-flex justify-content-end align-items-md-end aling-items-center d-flex flex-md-fill">
                            <div className='ml-3'>
                                <button onClick={() => setShowCreateModal(true)}
                                    className='flex items-center text-14 font-medium text-white !bg-primary px-2 py-1.5 rounded hover:opacity-90'>
                                    <svg className="mr4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                                    Create New</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="urer-table ml-24 mt-24">
                    <div className="def-table pr-24 !h-full">
                        <table className="table w-full font-worksans">
                            <thead className='text-left bg-black100 rounded-lg '>
                                <tr className='px-4 py-2'>
                                    <th>S.No</th>
                                    <th>Category Name</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories.map(function (item, index) {
                                    return <tr key={`${item.name}_${index}`}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>
                                            <Switch
                                                checked={item.is_active}
                                                onChange={() => handleMarkActiveDeActive(item.uuid, !item.is_active)}
                                                className={`${item.is_active ? 'bg-blue-600' : 'bg-gray-200'
                                                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                                            >
                                                <span
                                                    className={`${item.is_active ? 'translate-x-6' : 'translate-x-1'
                                                        } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                                                />
                                            </Switch>
                                            <button>{item.is_active}</button>
                                        </td>
                                        <td className="dropdown view-more">

                                            <button
                                                className="bg-tr border-0 "
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z"
                                                        fill="#B5B5BE"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                                                        fill="#B5B5BE"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z"
                                                        fill="#B5B5BE"
                                                    />
                                                </svg>
                                            </button>
                                            <div
                                                className="dropdown-menu dropdown-menu-right"
                                                aria-labelledby="dropdownMenuButton"
                                            >
                                                <a className="dropdown-item" onClick={() => handleEdit(item)}>
                                                    Edit
                                                </a>

                                            </div>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    showCreateModal && <CreateCategoryModal
                        closeModal={closeModal}
                        show={showCreateModal}
                        editGuideItem={editItem}
                        isEdit={isEdit}
                        handleCategoryChanges={handleCategoryChanges}
                        name={name}
                        handleSubmit={handleSubmit}
                        updateCategory={updateCategory}
                    />
                }
            </div>
        </>
    )
}

export default Category